
class WebSocketClient {
  constructor(url) {
    // Verifica se está em ambiente de produção
    const isProduction = window.location.hostname === 'slideparamissa.com.br' ||
                        window.location.hostname === 'www.slideparamissa.com.br';
    
    // Só conecta WebSocket em desenvolvimento
    if (!isProduction) {
      this.client = new WebSocket(url);

      this.client.onopen = (event) => {
        console.log("Conexão estabelecida", event);
      };

      this.client.onmessage = (message) => {
        console.log("Mensagem recebida:", message.data);
      };

      this.client.onerror = (error) => {
        console.error("Erro de WebSocket:", error);
      };

      this.client.onclose = (event) => {
        console.log("Conexão fechada:", event);
      };
    } else {
      console.log("WebSocket desabilitado em produção");
      this.client = null;
    }
  }
}

// Inicialize o WebSocketClient com a URL correta
const webSocketClient = new WebSocketClient(
  process.env.REACT_APP_WEBSOCKET_URL || "wss://slideparamissaapi.replit.app/ws",
);

export default webSocketClient;
